import { Clock3, Code2, TerminalSquare, UserRound } from "lucide-react";

import { type AgentUpdateMode, formatTime } from "../../agent-updates";
import { cn } from "@workanywhere/ui";
import { ConnectionBadge } from "./ui-bits";
import type { ConnectionState } from "./use-agent-updates";

export function AppHeader({
  connectionState,
  lastReceivedAt,
  mode,
  onModeChange,
}: {
  connectionState: ConnectionState;
  lastReceivedAt: string | null;
  mode: AgentUpdateMode;
  onModeChange: (mode: AgentUpdateMode) => void;
}) {
  return (
    <header className="flex min-h-14 flex-wrap items-center justify-between gap-3 border-b bg-card px-4 py-3">
      <div className="flex items-center gap-3">
        <div className="flex size-8 items-center justify-center rounded-md bg-primary text-primary-foreground">
          <TerminalSquare className="size-4" />
        </div>
        <div>
          <h1 className="text-base font-semibold leading-none">WorkAnywhere Agent Updates</h1>
          <p className="mt-1 text-xs text-muted-foreground">Scoped live workspace</p>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-4 text-sm">
        <div className="flex rounded-md border bg-background p-1" aria-label="Update display mode">
          <ModeButton active={mode === "normal"} icon={UserRound} label="Normal" onClick={() => onModeChange("normal")} />
          <ModeButton
            active={mode === "developer"}
            icon={Code2}
            label="Developer"
            onClick={() => onModeChange("developer")}
          />
        </div>
        <ConnectionBadge state={connectionState} />
        <div className="flex items-center gap-2 text-muted-foreground">
          <Clock3 className="size-4" />
          <span>Last event: {lastReceivedAt ? formatTime(lastReceivedAt) : "none"}</span>
        </div>
      </div>
    </header>
  );
}

function ModeButton({
  active,
  icon: Icon,
  label,
  onClick,
}: {
  active: boolean;
  icon: typeof UserRound;
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={onClick}
      className={cn(
        "inline-flex h-7 items-center gap-1.5 rounded px-2 text-xs font-medium text-muted-foreground transition-colors",
        active && "bg-primary text-primary-foreground shadow-xs",
      )}
    >
      <Icon className="size-3.5" />
      {label}
    </button>
  );
}
